var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-persist/~/lodash/_Promise.js
 ** module id = 1029
 ** module chunks = 0
 **/